import React from 'react';

import { FormattedMessage } from 'react-intl';
import messages from './messages';

import Spinner from 'legacy/main/components/UI/spinner';
import Wrapper from './components/Wrapper';
import Container, { NoFlexContainer } from './components/Container';
import ErrorContainer from './components/ErrorContainer';
import Header from './components/Header';
import Body, { NoFlexBody } from './components/Body';
import Button from './components/Button';

const Widget = ({
    hideHeader = false,
    isBeta,
    titleMessage = null,
    children = null,
    state,
    retry,
    manageErrorState = true,
    manageFetchingState = true,
    isFlex = true,
    isDraggable = false,
}) => {
    const renderContent = (content) => (
        <Wrapper>
            <Container>
                <Header show={!hideHeader} isBeta={isBeta}>
                    <FormattedMessage {...titleMessage} />
                </Header>
                <Body>{content}</Body>
            </Container>
        </Wrapper>
    );

    const renderNonFlexContent = (content) => (
        <NoFlexContainer>
            <Header show={!hideHeader} isBeta={isBeta} isFlex={isFlex} isDraggable={isDraggable}>
                <FormattedMessage {...titleMessage} />
            </Header>
            <NoFlexBody>{content}</NoFlexBody>
        </NoFlexContainer>
    );

    const renderChildren = () => {
        if (!isFlex) {
            return renderNonFlexContent(children);
        }
        return renderContent(children);
    };

    const renderLoader = () => renderContent(<Spinner />);

    const renderError = () => {
        const content = (
            <ErrorContainer>
                <p>
                    <FormattedMessage {...messages.error} />
                </p>
                <Button onClick={retry}>
                    <FormattedMessage {...messages.retry} />
                </Button>
            </ErrorContainer>
        );
        if (!isFlex) {
            return renderNonFlexContent(content);
        }
        return renderContent(content);
    };

    const renderNothing = () => {
        if (!isFlex) {
            return renderNonFlexContent(null);
        }
        return renderContent(null);
    };

    const { fetching, error, fetched } = state;

    if (fetching) {
        return manageFetchingState ? renderLoader() : renderChildren();
    }
    if (error) {
        return manageErrorState ? renderError() : renderChildren();
    }
    if (fetched) {
        return renderChildren();
    }
    return renderNothing();
};

export default Widget;
